import {
    startOfDay,
    startOfMonth,
    endOfMonth,
    startOfYear,
    endOfYear,
    subDays,
    subMonths,
    subYears,
  } from 'date-fns';
  
  export const HOURLY_PERIOD_OPTIONS = [
    { key: 'yesterday', label: '전일' },
    { key: 'today', label: '당일' },
    { key: 'threeDays', label: '3일' },
    { key: 'week', label: '1주일' },
  ];
  
  export const DAILY_PERIOD_OPTIONS = [
    { key: 'lastMonth', label: '전월' },
    { key: 'yesterday', label: '전일' },
    { key: 'today', label: '당일' },
    { key: 'week', label: '1주일' },
    { key: 'thisMonth', label: '당월' },
    { key: 'threeMonths', label: '3개월' },
  ];
  
  export const MONTHLY_PERIOD_OPTIONS = [
    { key: 'lastYear', label: '전년' },
    { key: 'lastMonth', label: '전월' },
    { key: 'thisMonth', label: '당월' },
    { key: 'threeMonths', label: '3개월' },
    { key: 'year', label: '1년' },
  ];
  
  export const HOURLY_PERIOD_RANGES = {
    yesterday: () => {
      const day = startOfDay(subDays(new Date(), 1));
      return { start: day, end: day, key: 'yesterday' };
    },
    today: () => {
      const day = startOfDay(new Date());
      return { start: day, end: day, key: 'today' };
    },
    threeDays: () => {
      const end = startOfDay(new Date());
      return { start: subDays(end, 2), end, key: 'threeDays' };
    },
    week: () => {
      const end = startOfDay(new Date());
      return { start: subDays(end, 6), end, key: 'week' };
    },
  };
  
  export const DAILY_PERIOD_RANGES = {
    lastMonth: () => {
      const ref = subMonths(new Date(), 1);
      return { start: startOfMonth(ref), end: endOfMonth(ref), key: 'lastMonth' };
    },
    yesterday: () => {
      const day = startOfDay(subDays(new Date(), 1));
      return { start: day, end: day, key: 'yesterday' };
    },
    today: () => {
      const day = startOfDay(new Date());
      return { start: day, end: day, key: 'today' };
    },
    week: () => {
      const end = startOfDay(new Date());
      return { start: subDays(end, 6), end, key: 'week' };
    },
    thisMonth: () => {
      const now = new Date();
      return { start: startOfMonth(now), end: startOfDay(now), key: 'thisMonth' };
    },
    threeMonths: () => {
      const end = startOfDay(new Date());
      return { start: startOfMonth(subMonths(end, 2)), end, key: 'threeMonths' };
    },
  };
  
  export const MONTHLY_PERIOD_RANGES = {
    lastYear: () => {
      const ref = subYears(new Date(), 1);
      return {
        start: startOfMonth(startOfYear(ref)),
        end: endOfMonth(endOfYear(ref)),
        key: 'lastYear',
      };
    },
    lastMonth: () => {
      const ref = subMonths(new Date(), 1);
      return { start: startOfMonth(ref), end: endOfMonth(ref), key: 'lastMonth' };
    },
    thisMonth: () => {
      const now = new Date();
      return { start: startOfMonth(now), end: endOfMonth(now), key: 'thisMonth' };
    },
    threeMonths: () => {
      const now = new Date();
      return {
        start: startOfMonth(subMonths(now, 2)),
        end: endOfMonth(now),
        key: 'threeMonths',
      };
    },
    year: () => {
      const now = new Date();
      return {
        start: startOfMonth(subMonths(now, 11)),
        end: endOfMonth(now),
        key: 'year',
      };
    },
  };
  